import { memo, useCallback } from 'react';
import { DialogTrigger } from 'react-aria-components';

import { ComponentContextProps, renderWithContext } from '@/components';
import { Button, ButtonProps, Label, Popover, TextField } from '@/components/core';

import { useComponent } from '../useComponent';
import { Input } from './Input';

type BaseProps = Omit<ButtonProps, 'onChange'> & Partial<ComponentContextProps>;

export interface EditableProps extends BaseProps {
  label?: string | null;
  onChange?: (value: string) => void | undefined;
  defaultValue: string | null | undefined;
}

const IEditable = ({ variant, onChange, children, label, defaultValue, ...rest }: EditableProps) => {
  const context = useComponent({ variant });

  return renderWithContext(
    <DialogTrigger>
      <Button variant="plain" {...rest}>
        {children}
      </Button>

      <Popover className="p-2">
        <TextField defaultValue={defaultValue ?? undefined} onChange={onChange}>
          {label && <Label>{label}</Label>}
          <Input />
        </TextField>
      </Popover>
    </DialogTrigger>,
    context
  );
};

export const Editable = memo(IEditable) as typeof IEditable;
